var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3733 0.545169C12.1496 -0.181724 13.4082 -0.181722 14.1844 0.545169L15.4178 1.70003C16.1941 2.42691 16.1941 3.60544 15.4178 4.33233L5.63812 13.4897C5.39924 13.7133 5.10343 13.8763 4.77861 13.9632L1.08599 14.9511C0.788497 15.0307 0.468322 14.953 0.249548 14.7481C0.0307743 14.5433 -0.0521952 14.2435 0.0327961 13.965L1.08784 10.5073C1.18064 10.2032 1.3547 9.92614 1.59358 9.70246L11.3733 0.545169ZM12.9797 1.6733C12.8687 1.56946 12.6889 1.56946 12.5781 1.6733L11.1439 3.01617L12.7789 4.54707L14.2131 3.2042C14.3239 3.10036 14.3239 2.932 14.2131 2.82816L12.9797 1.6733ZM11.574 5.6752L9.93913 4.1443L2.79838 10.8306C2.76425 10.8625 2.73939 10.9021 2.72612 10.9456L2.09236 13.0226L4.31053 12.4291C4.35693 12.4168 4.39918 12.3935 4.43332 12.3615L11.574 5.6752Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic-edit.c42081f84ab8fe8d7f7b216ebae96747.svg";
export { ForwardRef as ReactComponent };